import { makeStyles } from 'tss-react/mui';

const name = 'WidgetSection';

export const useWidgetSectionStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
}));
